import type {ReactElement} from 'react';
import {useEffect, useMemo, useState} from 'react';
import App from '@Components/app';
import {ModalContainer} from '@Components/modal-container';
import {LoadingToast} from '@Components/loading-toast';
import {renderApp} from '@Utils/renderApp.util';
import {EmailMakerReact} from '@EmailMakerReact/email-maker-react';
import {EmailMakerAiRedesignFeedbackToast} from '@EmailMakerReact/components/email-maker-ai-redesign-feedback-toast/email-maker-ai-redesign-feedback-toast';
import type {EmailMakerImmutableStore} from '@EmailMakerReact/email-maker-react.types';

export function EmailMakerReactPage(): ReactElement {
  const [i18Loaded, setI18Loaded] = useState<boolean>(false);
  const emailMakerStore = useMemo<EmailMakerImmutableStore>(() => readEmailMakerStore(), []);

  useEffect(() => {
    window.PMW.initI18next(window.PMW.LANGUAGE, () => {
      setI18Loaded(true);
    });
  }, []);

  if (!i18Loaded) {
    return <App />;
  }

  return (
    <App nonStrictModeChildren={<EmailMakerReact store={emailMakerStore} />}>
      <ModalContainer />
      <LoadingToast />
      <EmailMakerAiRedesignFeedbackToast />
    </App>
  );
}

function readEmailMakerStore(): EmailMakerImmutableStore {
  return window.reactPageProps as EmailMakerImmutableStore;
}

renderApp(<EmailMakerReactPage />, 'email-maker-react-app');
